<template>
  <div class="retrieve-page">
    <a-card class="retrieve-card">
      <div class="retrieve-title">{{ $t('retrievePassword') }}</div>
      <dol-form-model :model="editForm" :rules="validateRules" ref="editForm">
        <a-form-model-item class="register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}">
          <template slot="label">
            <span>{{ $t('verifyType') }}</span>
          </template>
          <a-input-group compact>
            <a-radio-group v-model.trim="editForm.SEND_TYPE">
              <a-radio :value="0">
                {{ $t('mobileVerify') }}
              </a-radio>
              <a-radio :value="1">
                {{ $t('emailVerify') }}
              </a-radio>
            </a-radio-group>
          </a-input-group>
        </a-form-model-item>

        <a-form-model-item class="retrieve-form-item" v-if="editForm.SEND_TYPE == 0" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="MOBILE">
          <template slot="label">
            {{ $t('mobile') }}
          </template>
          <a-input v-model.trim="editForm.MOBILE" :placeholder="$t('pleaseEnterYourMobilePhoneNumber')" size="large">
            <dol-select
                slot="addonBefore"
                size="large"
                autoSelect
                v-model.trim="editForm.MOBILE_PREFIX"
                source="server"
                server-type="DotNet"
                :dot-net-table-type="3"
                :dot-net-columns="false"
                dotNetReturnListField="DATA_LIST"
                :dot-net-table-name="`SELECT BS.CODE_ID,BS.CODE_CODE,BS.CODE_NAME,BS.TYPE_ID,BST.TYPE_CODE,BST.TYPE_NAME,
                BST.IS_VISIBLE AS TYPE_IS_VISIBLE
                FROM BM_BASE_CODE BS, BM_BASE_CODE_TYPE BST
                WHERE BS.TYPE_ID = BST.TYPE_ID
                AND BST.TYPE_CODE='2009'`"
                label-field="CODE_NAME"
                key-field="CODE_NAME"
                value-field="CODE_NAME"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item class="register-form-item" v-else :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}"  prop="EMAIL">
          <template slot="label">
            <span>{{ $t('email') }}</span>
          </template>
          <a-input size="large" style="width: 100%" v-model.trim="editForm.EMAIL" :placeholder="$t('pleaseEnterYourEmailAddress')" />
        </a-form-model-item>
        <a-form-model-item v-if="editForm.SEND_TYPE == 0" class="register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="VCODE">
          <template slot="label">
            <span>{{ $t('messageAuthenticationCode') }}</span>
          </template>
          <a-input-group compact>
            <a-input v-model.trim="editForm.VCODE" :placeholder="$t('pleaseEnterTheSmsVerificationCode')" size="large" style="width: 50%" />
            <a-button ref="button" class="register-form-sms-button" :disabled="time !== 60" @click="getSmsCode" type="primary">{{ buttonText }}</a-button>
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item v-else class="register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="VCODE">
          <template slot="label">
            <span>{{ $t('emailMessage') }}</span>
          </template>
          <a-input-group compact>
            <a-input v-model.trim="editForm.VCODE" :placeholder="$t('pleaseEnterTheSmsVerificationCode')" size="large" style="width: 50%" />
            <a-button ref="button" class="register-form-sms-button" :disabled="time !== 60" @click="getSmsCode" type="primary">{{ buttonText }}</a-button>
          </a-input-group>
        </a-form-model-item>
        <!--        <a-form-model-item class="retrieve-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="VCODE">
                  <template slot="label">
                    {{ $t('messageAuthenticationCode') }}
                  </template>
                  <a-input-group compact>
                    <a-input v-model.trim="editForm.VCODE" :placeholder="$t('pleaseEnterTheSmsVerificationCode')" style="width: 50%" size="large"/>
                    <a-button class="retrieve-sms-button" :disabled="time !== 60" @click="getSmsCode" ref="button">
                      {{ buttonText }}
                    </a-button>
                  </a-input-group>
                </a-form-model-item>-->
        <a-form-model-item class="retrieve-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="NEW_PASSWORD">
          <template slot="label">
            {{ $t('newPassword') }}
          </template>
          <a-input-password v-model.trim="editForm.NEW_PASSWORD" autocomplete="new-password" :placeholder="$t('pleaseEnterANewPassword')" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="register-form-item" :labelCol="{span: labelColNum}" :wrapperCol="{span: wrapperColNum}" prop="oldPassword">
          <template slot="label">
            {{ $t('confirmPassword') }}
          </template>
          <a-input-password v-model.trim="editForm.oldPassword" autocomplete="new-password" :placeholder="$t('pleaseEnterYourPasswordAgain')"
                            type="password" size="large"/>
        </a-form-model-item>
        <a-form-model-item class="retrieve-form-item retrieve-form-button" label=" " :labelCol="{span: labelColNum}"
                           :wrapperCol="{span: wrapperColNum}" props='button'>
          <a-button @click="retrievePass" size="large" block>{{ $t('confirm') }}</a-button>
        </a-form-model-item>
      </dol-form-model>
    </a-card>
  </div>
</template>

<script>
import loginHeader from "../../components/common/login-header";
import moment from "moment";
export default {
  name: "retrievePassword",
  components: {loginHeader},
  data(){
    return{
      editForm: {
        SEND_TYPE: 0
      },
      validateRules: {
        MOBILE: [{required: true, message: this.$t('pleaseEnterMobilePhoneNumber'), trigger: ['blur', 'change']}],
        EMAIL: [{required: true, message: this.$t('pleaseFillInTheEmail'), trigger: ['blur', 'change']}],
        VCODE: [{required: true, message: this.$t('enterTheSmsVerificationCode'), trigger: ['blur', 'change']}],
        NEW_PASSWORD: [{required: true, message: this.$t('pleaseFillInTheUserName'), trigger: ['blur', 'change']}],
        oldPassword: [
          {required: true, message: this.$t('pleaseConfirmPassword'), trigger: ['blur', 'change']},
          {
            validator: (rule, value, callback) => {
              if (value !== this.editForm.NEW_PASSWORD) {
                callback(this.$t('twoPasswordsAreDifferent'))
              } else {
                callback()
              }
            }
          }
        ],
      },
      buttonText: this.$t('obtainTheSmsVerificationCode'),
      time: 60,
      smsLoading: false,
      moment,
      loading: true,
      timeOut: '',
      labelColNum:this.$i18n.locale === 'zh'?6:this.$i18n.locale === 'en'?7:24,
      wrapperColNum:this.$i18n.locale === 'zh'?18:this.$i18n.locale === 'en'?17:24
    }
  },
  watch:{
    '$i18n.locale'(){
      this.labelColNum = this.$i18n.locale === 'zh'?6:this.$i18n.locale === 'en'?7:24;
      this.wrapperColNum = this.$i18n.locale === 'zh'?18:this.$i18n.locale === 'en'?17:24;
      this.buttonText = this.$t('obtainTheSmsVerificationCode');
    }
  },
  methods:{
    clearTimeInterval(){
      this.smsLoading = false;
      this.time = 60;
      this.buttonText = this.$t('obtainTheSmsVerificationCode');
      localStorage.removeItem('retrieveSmsTime');
      clearInterval(this.timeOut);
    },
    countDown(){
      this.smsLoading = true;
      this.time = this.moment(localStorage.getItem('retrieveSmsTime')).diff(this.moment(), 'seconds');
      this.timeOut = setInterval(() =>{
        this.buttonText = `${this.time}${this.$t('youCanResendItLater')}`;
        if(this.time-- <= 0){
          this.smsLoading = false;
          this.time = 60;
          this.buttonText = this.$t('obtainTheSmsVerificationCode');
          localStorage.removeItem('retrieveSmsTime');
          clearInterval(this.timeOut);
        }
      },1000)
    },
    getSmsCode() {
      this.$refs.editForm.validateField([this.editForm.SEND_TYPE == 0 ? 'MOBILE': 'EMAIL'], (val) => {
        if (!val) {
          if(this.loading){
            this.$message.info(this.$t('sendWait'));
            this.loading = false;
            localStorage.setItem('retrieveSmsTime',this.moment().add('60',"second"));
            this.countDown();
            this.$h5Api({
              type: '2002',
              data: [{
                "MOBILE": this.editForm.SEND_TYPE == 0 ? this.editForm.MOBILE:this.editForm.EMAIL,
                "MOBILE_PREFIX": this.editForm.MOBILE_PREFIX,
                "SEND_TYPE": this.editForm.SEND_TYPE,
              }],
              showMessage: false,
            }).then(({data, total}) => {
            }).catch(e =>{
              this.clearTimeInterval();
              this.$message.info(this.$t(e.status))
            }).finally(() =>{
              this.loading = true;
              this.smsLoading = true;
            })
          }
        }
      })
    },
    retrievePass() {
      this.$refs.editForm.validate((val) => {
        delete this.editForm.oldPassword;
        if (val) {
          this.$h5Api({
            type: '2003',
            data: [{
              "MOBILE": this.editForm.SEND_TYPE == 0 ? this.editForm.MOBILE:this.editForm.EMAIL,
              "MOBILE_PREFIX": this.editForm.MOBILE_PREFIX,
              "SEND_TYPE": this.editForm.SEND_TYPE,
              "VCODE": this.editForm.VCODE,
              "NEW_PASSWORD": this.editForm.NEW_PASSWORD,
            }],
          }).then(({data, total}) => {
            this.$router.push('login')
          }).catch(e =>{
            this.$message.info(this.$t(e.status))
          })
        }
      })
    }
  },
  created() {
    if (localStorage.getItem('retrieveSmsTime')) {
      this.countDown();
    }
  }
}
</script>

<style lang="scss">
.retrieve-page {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #F5F7F9;

  .retrieve-card {
    padding: 8px 180px;
    width: 990px;
    margin: 48px auto;

    .retrieve-title {
      text-align: center;
      margin-bottom: 32px;
      font-size: 24px;
      font-weight: 700;
      color: #333333;
      line-height: 33px;
    }

    .retrieve-form-button {
      label::after {
        content: '';
        position: relative;
        top: -0.5px;
        margin: 0 8px 0 2px;
      }

      button {
        background-color: #1F6CBA;
        color: #FFFFFF;
        border: 0;
      }
    }

    .retrieve-form-item {
      margin-bottom: 22px;

      .retrieve-sms-button {
        width: 50%;
        height: 40px;
        background-color: #E5EEF7;
        color: #666666;
        border: 0;
      }

      label {
        font-size: 16px;
      }

      .retrieve-form-item_message {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        letter-spacing: 1px;
      }

    }
    .register-form-sms-button{
      width: 50%;
      height: 40px;
      background: #E5EEF7;
      border-color:#E5EEF7;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }

    .register-form-item{
      label{
        font-size: 16px;
      }
      span{
        font-size: 16px;
      }
    }
  }
}
</style>